import { QueryClient, useQuery } from "@tanstack/react-query";
import { api, ApiError, setCsrfToken } from "./api.js";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (n, e) => !(e instanceof ApiError && e.status >= 400 && e.status < 500) && n < 2,
      refetchOnWindowFocus: false,
      staleTime: 10_000,
    },
  },
});

export interface SessionInfo {
  kind: "account" | "staff";
  role: "admin" | "arzt" | "apotheke";
  displayName: string;
  email: string | null;
  pharmacyId: string | null;
  uiLanguage: string;
  mfa: { state: "ausstehend" | "bestaetigt" | "nicht_erforderlich"; configured: boolean; required: boolean };
  mustChangePassword: boolean;
  mustChangePin: boolean;
  csrfToken: string;
  idleTimeoutSeconds: number;
  absoluteExpiresAt: string;
}

export interface SessionResponse {
  authenticated: boolean;
  session: SessionInfo | null;
  device: { id: string; kind: string; name: string; csrfToken: string } | null;
  mailMode: "smtp" | "manual" | "log";
}

export const SESSION_KEY = ["session"] as const;

/** Sitzung (setzt auch das CSRF-Token für den API-Client). */
export function useSession() {
  return useQuery({
    queryKey: SESSION_KEY,
    queryFn: async () => {
      const r = await api<SessionResponse>("/auth/session", { background: true });
      setCsrfToken(r.session?.csrfToken ?? r.device?.csrfToken);
      return r;
    },
    staleTime: 30_000,
  });
}

export const refreshSession = () => queryClient.invalidateQueries({ queryKey: SESSION_KEY });
